import {Box} from '@yandex-delivery/blocks'
import {Image} from '@yandex-delivery/blocks/image'
import React from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import type {TagLineWidgetProps as Props} from '../types'
import {Tag} from './components/Tag'
import * as classes from './TagLine.classes'

export const TagLineWidget = ({config: {tags}}: Props): React.ReactElement => {
  return (
    <Box flexDirection="row" flexWrap="wrap" gap="xs">
      {tags.map(({action, icon, text}) => (
        <Tag key={`${action}_${text}`} action={action}>
          {text}
          {icon && <Image alt="" className={classes.inlineImage} height={20} src={tagToUrl(icon.image_tag)} />}
        </Tag>
      ))}
    </Box>
  )
}
